import React from "react"
import { observer, useLocalObservable } from "mobx-react"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { NoContent } from "@src/app/components/NoContent/Index"
import { ConvertsCollection } from "@src/pages/transactionsSwap/classes/ConvertsCollection"
import { SwapTable } from "@src/pages/transactionsSwap/ui/SwapTable"
import { TableFilters } from "@src/shared/componemts/TableFilter"
import css from "./index.module.css"

export const TransactionsSwapPage = observer(() => {
  const converts = useLocalObservable(() => new ConvertsCollection())

  return (
    <div className={css.container}>
      <TableFilters {...converts.filter.props}></TableFilters>

      {choose(
        [converts.isLoading && converts.isEmpty, <LoadingBlock />],
        [
          converts.isEmpty,
          <NoContent
            paragraph={
              converts.filter.state.status
                ? `You have not converts with the status ${converts.filter.state.status}`
                : "Wait for your first convert to start receiving reports."
            }
            title="No Converts Yet"
          />,
        ],
        [!converts.isEmpty, <SwapTable collection={converts} />],
      )}
    </div>
  )
})
